import { NgModule } from '@angular/core';
import { Routes, RouterModule, TitleStrategy } from '@angular/router';
import { AuthorizedGuard } from '@core/guards/authorized.guard';
import { LandingComponent, ErrorComponent } from '@core/containers';
import { PermissionGuard } from '@core/guards/permission.guard';
import { UnauthorizedComponent } from '@core/containers/unauthorized/unauthorized.component';
import { LoadingReportComponent } from '@core/containers/loading-report/loading-report.component';
import { TemplatePageTitleStrategy } from '@utils/TemplatePageTitleStrategy';

const routes: Routes = [
  { path: '', redirectTo: '/secure/dashboard', pathMatch: 'full', data: { name: 'dashboard' } },
  {
    path: 'secure',
    canActivate: [AuthorizedGuard, PermissionGuard],
    loadChildren: () => import('./secure/secure.module').then(m => m.SecureModule),
    data: { name: 'secure' }
  },
  { path: 'login', loadChildren: () => import('./login/login.module').then(m => m.LoginModule), data: { name: 'login' } },
  { path: 'preview', loadChildren: () => import('./preview/preview.module').then(m => m.PreviewModule), data: { name: 'preview' } },
  { path: 'landing', component: LandingComponent, data: { name: 'LandingComponent' } },
  { path: 'intelligylanding', component: LandingComponent, data: { name: 'LandingComponent' } },
  { path: 'intelligylogin', component: LandingComponent , data: { name: 'LandingComponent' }},
  { path: 'error', component: ErrorComponent, data: { name: 'ErrorComponent' } },
  { path: 'loading-report', component: LoadingReportComponent, data: { name: 'LoadingReportComponent' } },
  { path: 'unauthorized', component: UnauthorizedComponent, data: { name: 'UnauthorizedComponent' } },
  { path: 'logout', loadChildren: () => import('./logout/logout.module').then(m => m.LogoutModule), data: { name: 'logout' } },
  { path: 'signout', loadChildren: () => import('./signout/signout.module').then(m => m.SignoutModule), data: { name: 'signout' } }
  // { path: '**', component: NotFoundPageComponent } //Added in building of multi level menu routing
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: false })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
